'use client';

import { useState } from 'react';
import Image from 'next/image';
import Button from '../../components/Button';
import { useRouter } from 'next/navigation';
import styles from './page.module.css';
import { useTranslation } from 'next-i18next';

export default function Home() {
  const [isLoading] = useState(false);
  const router = useRouter();
  const { t, i18n } = useTranslation('common');

  const handleSignIn = () => {
    router.push('/signin');
  };

  const handleEnterToWin = () => {
    router.push('/signup');
  };

  return (
    <div className={styles.page}>
      {/* Background with actual asset */}
      <div className={styles.backgroundPattern}></div>

      {/* Content Container */}
      <div className={styles.contentContainer}>
        <Image
          src={i18n.language === 'ar' ? '/hero-image-ar.png' : '/hero-image.png'}
          alt="Play to Win"
          className={styles.playToWin}
          width={1920}
          height={1080}
          sizes="100vw"
          priority
        />
        {/* Button and Sign In Section */}
        <div className={styles.bottomSection}>
          <Button onClick={handleEnterToWin} disabled={isLoading} size="large">
            {isLoading ? t('Loading...') : t('Enter to Win')}
          </Button>
          <div
            className={styles.signInContainer}
            style={{ paddingTop: '20px' }}
          >
            <span className={styles.signInText}>
              {t('Already have an account?')}
            </span>
            <span className={styles.signInLink} onClick={handleSignIn}>
              {t('Sign In')}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
